// Module
var code = "<span ng-show=\"$ctrl.showLabel\" class=\"product-state-label {{$ctrl.availabilityStateCssClass}}\" system-dictionary=\"{{$ctrl.availabilityStateDictionaryKey}}\" ng-cloak> </span>";
// Exports
module.exports = code;